import { DialogContent, DialogContentText, Typography } from '@mui/material';
import ModalCustom from 'components/Modal/Modal';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { closeDialogAction } from 'store/actions/dialogsActions';
// import { getbaseLineOrderAction } from 'store/actions/changeBaselineActions';
import { useAppState } from 'store/Provider';
import useManagementService from 'features/Management/services/useManagementService';

const BaselineConfirmation = () => {
  const { state, dispatch } = useAppState();
  const { dialogs } = state;
  const isOpen = dialogs.changeBaselineOpenDialog;
  const { order } = dialogs?.data;
  const { baselineEngagementParaPage } = useManagementService();
  const [t] = useTranslation();

  const confirmFn = () => {
    baselineEngagementParaPage(order);
    // dispatch(getbaseLineOrderAction(order));
    dispatch(closeDialogAction('changeBaselineOpenDialog'));
  };
  const dialogBody = (
    <DialogContent>
      <DialogContentText>
        <Typography>
          <strong>{t('Are you sure you want to change the baseline of this order?')}</strong>
        </Typography>
        <Typography>
          <br />
          <strong>{t('Note')}</strong> {t('baselineChangeNote')}
        </Typography>
      </DialogContentText>
    </DialogContent>
  );
  return (
    <ModalCustom
      open={isOpen}
      modalName="changeBaselineOpenDialog"
      onClose={() => dispatch(closeDialogAction('changeBaselineOpenDialog'))}
      onConfirm={() => confirmFn()}
      titleText="Confirmation"
      confirmText=" Yes "
      cancelText="Cancel"
      body={dialogBody}
      size="md"
      confirmLoad
    />
  );
};

export default BaselineConfirmation;
